export const tableColumnTranslations = {
  fr: {
    'Columns': 'Colonnes',
    'Visible columns': 'Colonnes visibles',
    'Required column': 'Colonne obligatoire',
    'Restore default columns': 'Rétablir les colonnes par défaut',
    'Column changes could not be saved in this browser.': 'Les modifications des colonnes n’ont pas pu être enregistrées dans ce navigateur.',
  },
  ar: {
    'Columns': 'الأعمدة',
    'Visible columns': 'الأعمدة المرئية',
    'Required column': 'عمود مطلوب',
    'Restore default columns': 'استعادة الأعمدة الافتراضية',
    'Column changes could not be saved in this browser.': 'تعذّر حفظ تغييرات الأعمدة في هذا المتصفح.',
  },
  tr: {
    'Columns': 'Sütunlar',
    'Visible columns': 'Görünür sütunlar',
    'Required column': 'Zorunlu sütun',
    'Restore default columns': 'Varsayılan sütunları geri yükle',
    'Column changes could not be saved in this browser.': 'Sütun değişiklikleri bu tarayıcıda kaydedilemedi.',
  },
}
